/**
 * 用户管理
 */
import Layout from "../../pages/layout/Frame";

const userRouter = {
  path: "/user",
  component: Layout,
  meta: { title: "用户管理" },
  name: "user_list",
  children: [
    {
      path: "/user/index",
      component: () => import("../../pages/user/index"),
      meta: { title: "用户管理" },
      name: "user_list"
    },
    {
      path: "/user/inviteUser",
      component: () => import("../../pages/user/inviteUser"),
      meta: { title: "邀请人列表" },
      name: "user_list"
    },
    {
      path: "/user/h5Recharge",
      component: () => import("../../pages/user/h5Recharge"),
      meta: { title: "便捷充值" },
      name: "h5_recharge"
    }
  ]
};

export default userRouter;
